import { render, staticRenderFns } from "./IresDeviceStatus.vue?vue&type=template&id=461982aa&scoped=true&"
import script from "./IresDeviceStatus.vue?vue&type=script&lang=ts&"
export * from "./IresDeviceStatus.vue?vue&type=script&lang=ts&"
import style0 from "./IresDeviceStatus.vue?vue&type=style&index=0&id=461982aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461982aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
